<template>
  <div class="update-contact-container" @click.stop>
    <div class="close-icon" @click="$emit('close')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" style="transform:rotate(45deg);position:relative;top:4px;"><g fill="none"><g style="stroke-width:3;stroke:#F7103C"><path d="M8 8L8-1 8 8 -1 8 8 8ZM8 8L17 8 8 8 8 17 8 8Z"/></g></g></svg>
    </div>
    <div class="header">Update Contact Information</div>
    <div class="fields">
      <input type="text" class="input" v-model="name" placeholder="contact name"/>
      <input type="text" class="input" v-model="email" placeholder="contact@email.com"/>
      <input type="text" class="input" v-model="phone" placeholder="+123 456"/>
    </div>
    <div class="update-button" @click="updateContact()">
      Update
    </div>
  </div>
</template>

<script>
import projectService from '@/services/project-service.js'

export default {
  name: 'UpdateContact',
  props: {
    contact: {
      type: Object,
      required: true
    },
    projectName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',

      updateInProgress: true,
      err: null,
    }
  },
  created() {
    this.name = this.contact.name
    this.email = this.contact.email
    this.phone = this.contact.phone
  },
  methods: {
    async updateContact() {
      this.updateInProgress = true

      await projectService.updateContact(this.projectName, this.updatedContact)

      this.$store.commit('addToProject', { project: this.projectName, key: 'contact', value: this.updatedContact})
      this.updateInProgress = false
      this.$emit('close')
    }
  },
  computed: {
    updatedContact() {
      return { name: this.name, email: this.email, phone: this.phone }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.update-contact-container {
  padding: 50px;
  text-align: left;
  border-radius: $border-radius;
  position: relative;

  .header {
    margin-bottom: 30px;
    font-size: 20px;
  }

  .fields {
    input {
      margin: 10px 0px;
      border-radius: $border-radius;
    }
  }

  .update-button {
    margin-top: 50px;
    padding: 20px 30px;
    background-color: $primary;
    border-radius: $border-radius;
    color: white;
    text-align: center;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      box-shadow: 2px 2px 10px rgba(black, 0.4);
    }

    img {
      max-height: 30px;
    }
  }

  .close-icon {
    position: absolute;
    top: -16px;
    right: -16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 2px 2px 10px rgba(black, 0.4);
    text-align: center;
    cursor: pointer;
  }
}
</style>